export default "__VITE_ASSET__DvjjvmyD__"